import { createClient } from '@supabase/supabase-js';

// CRA usa REACT_APP_ como prefixo para variáveis de ambiente
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

// Create Supabase client with fallback values for development
// In production, these should be properly configured
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key'
);

